var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"my-news"},[_c('div',{staticClass:"content-new",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }